export const ATTSCHEDULEDETAIL_LOADING = "ATTSCHEDULEDETAIL_LOADING";
export const ATTSCHEDULEDETAIL_RESET = "ATTSCHEDULEDETAIL_RESET";
export const GET_ATTSCHEDULEDETAIL = "GET_ATTSCHEDULEDETAIL";
export const GET_ATTSCHEDULEDETAIL_SUCCESS = "GET_ATTSCHEDULEDETAIL_SUCCESS";
export const GET_ATTSCHEDULEDETAIL_FAIL = "GET_ATTSCHEDULEDETAIL_FAIL";
export const DELETE_ATTSCHEDULEDETAIL = "DELETE_ATTSCHEDULEDETAIL"
export const DELETE_ATTSCHEDULEDETAIL_SUCCESS = "DELETE_ATTSCHEDULEDETAIL_SUCCESS"
export const DELETE_ATTSCHEDULEDETAIL_FAIL = "DELETE_ATTSCHEDULEDETAIL_FAIL"
export const UPDATE_ATTSCHEDULEDETAIL = "UPDATE_ATTSCHEDULEDETAIL"
export const UPDATE_ATTSCHEDULEDETAIL_SUCCESS = "UPDATE_ATTSCHEDULEDETAIL_SUCCESS"
export const UPDATE_ATTSCHEDULEDETAIL_FAIL = "UPDATE_ATTSCHEDULEDETAIL_FAIL"
export const ADD_NEW_ATTSCHEDULEDETAIL = "ADD_NEW_ATTSCHEDULEDETAIL"
export const ADD_ATTSCHEDULEDETAIL_SUCCESS = "ADD_ATTSCHEDULEDETAIL_SUCCESS"
export const ADD_ATTSCHEDULEDETAIL_FAIL = "ADD_ATTSCHEDULEDETAIL_FAIL"